import React, { FC, useEffect, useMemo, useState } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import SupplierLocationPageDisplay from '../supplier_location_page_display/SupplierLocationPageDisplay';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import OWResult from '../OWResult';

const { Content } = Layout;

require('./SupplierLocationsDetailDetailsPage.less');

const SupplierLocationsDetailPage: FC<any> = ({
	getLocation,
	match,
	location,
	locationsFetching,
	locationsError,
}): React.ReactElement => {
	const fetching = locationsFetching && !nullSafeGet('id', location);
	const locationAccessError = nullSafeGetOrElse('length', locationsError, 0) > 0;

	return fetching ? (
		<PageLoadingPlaceholder />
	) : locationAccessError ? (
		<OWResult
			error={'Do not have permission to perform this action'}
			title="You do not have access to this location"
		/>
	) : (
		<Content className="supplierLocationsDetailDetailsPage">
			<SupplierLocationPageDisplay
				key={nullSafeGet('id', location)}
				record={location}
				locationsFetching={fetching}
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	locationsError: state.locations.fetchErrors,
	locationsFetching: state.locations.fetching,
	location: getEntityById(ownProps.match.params.id, state.locations),
	match: ownProps.match,
});

const mapDispatchToProps = (dispatch) => ({
	getLocation: (id) => dispatch(locationsRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierLocationsDetailPage)
);
